import { dsbridge } from '@lb-public/jsbridge'

function renderCurrentUserText(targetDom, accountList) {
  if (accountList.length <= 1) return
  const currentAccount = accountList.find((account) => account.account_channel === targetDom.data('current-channel'))
  if (!currentAccount) return
  const noStr = currentAccount.no || targetDom.data('not-open-text')
  targetDom[0].innerText = `${currentAccount.account_name} (${noStr})`
}

$(document).on('turbolinks:load', () => {
  const targetDom = $("#current_user_text")
  if (!targetDom.length) return
  dsbridge.call('lbGetToken', resp => {
    try {
      const { token: xBridgeToken } = JSON.parse(resp).data || {}
      fetch(targetDom.data('api-url'), {
        headers: {
          'x-bridge-token': xBridgeToken,
        }
      }).then(resp => {
          return resp.json()
        }
      ).then(({ code, ...res}) => {
        if (code != 0) return
        renderCurrentUserText(targetDom, res.data.status)
      })
    } catch (e) {
      console.error('fetch token error', e.message)
    }
  })
})